import type { AgencyCategory } from '@saaga/shared/interfaces/agencies.interface'
import type { ReactNode } from 'react'

import { Badge } from '@/components/ui/badge'

import { agencyCategoryLabelMap } from './agencies.mock'

interface AgencyDetailCategoriesProps {
  categoryList: AgencyCategory[]
}

export const AgencyDetailCategories = ({
  categoryList,
}: AgencyDetailCategoriesProps): ReactNode => {
  if (categoryList.length === 0) {
    return null
  }

  return (
    <div className="agency-detail-categories flex flex-wrap gap-2">
      {categoryList.map((category) => (
        <Badge key={category} variant="outline" className="text-sm font-normal">
          {agencyCategoryLabelMap[category]}
        </Badge>
      ))}
    </div>
  )
}

AgencyDetailCategories.displayName = 'AgencyDetailCategories'
